// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServiceLiteDto
 */
export interface IServiceLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IServiceLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServiceLiteDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IServiceLiteDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IServiceLiteDto
     */
    service_type?: IServiceLiteDtoServiceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IServiceLiteDtoServiceTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}


/**
 * Check if a given object implements the IServiceLiteDto interface.
 */
export function instanceOfIServiceLiteDto(value: object): value is IServiceLiteDto {
    return true;
}

export function IServiceLiteDtoFromJSON(json: any): IServiceLiteDto {
    return IServiceLiteDtoFromJSONTyped(json, false);
}

export function IServiceLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'service_type': json['service_type'] == null ? undefined : json['service_type'],
    };
}

export function IServiceLiteDtoToJSON(json: any): IServiceLiteDto {
    return IServiceLiteDtoToJSONTyped(json, false);
}

export function IServiceLiteDtoToJSONTyped(value?: IServiceLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'service_type': value['service_type'],
    };
}

